import { useEffect, useRef, useState } from "react";
import {
  MdKeyboardArrowRight,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import {
  changeIntoString,
  generateDates,
  generateTimeSlots,
} from "../../utils/dates";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import moment from "moment";
import AppointmentService from "../../Services/AppointmentService";
import { Flex, Input, message, Select, Spin } from "antd";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import Layout from "../../Layout";
import PatientService from "../../Services/PatientService";
import UserService from "../../Services/UserService";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { IoLocationSharp } from "react-icons/io5";
import { bookFreeAppointment } from "../../Redux/actions/appointmentActions";

const SideDrawer = ({ selectedDoctor, referralId, closeDrawer }) => {
  const { patientData } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.appt);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [dates, setDates] = useState([]);
  const [selectedDoctorSlots, setSelectedDoctorSlots] = useState(null);
  const [slotsLoader, setSlotsLoader] = useState(false);
  const [morningSlots, setMorningSlots] = useState([]);
  const [slotVisible, setSlotVisible] = useState(false);
  const [eveningSlots, setEveningSlots] = useState([]);
  const [lastDate, setLastDate] = useState(new Date());
  const [selectedPatient, setSelectedPatient] = useState(patientData);
  const [famList, setFamList] = useState([]);
  const [consReason, setConsReason] = useState("");
  const [consultationType, setConsultationType] = useState("video");
  const pincodeFromSession = sessionStorage.getItem("availPin");
  const [checkingPincode, setCheckingPincode] = useState(
    pincodeFromSession ? pincodeFromSession : ""
  );
  const [consCode, setConsCode] = useState("");
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const [visitingAddress, setVisitingAddress] = useState("");
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const [displayingSlot, setDisplayingSlot] = useState(null);

  useEffect(() => {
    const datesArr = generateDates(new Date(), 30);
    setDates(datesArr);
    if (datesArr && datesArr.length !== 0) {
      handleSelectDate(datesArr[0]);
    }
  }, [selectedDoctorSlots]);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      getFamilyList();
      setSelectedPatient(patientData);
    }
  }, [patientData]);

  const getFamilyList = async () => {
    if (patientData.parentPatientId) return;
    const payload = {
      parentPatientId: patientData?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchSlots(selectedDoctor.userId);
  }, []);

  const fetchSlots = async (doctorId) => {
    const payload = {
      userId: doctorId,
      status: 1,
    };
    setSlotsLoader(true);

    try {
      const response = await AppointmentService.UserSavedTemplates(payload);

      if (response.data && response.data.length !== 0) {
        setSelectedDoctorSlots(response.data);
        const selectedDate = moment(
          selectedDoctor?.selectedDate,
          "MM/DD/YYYY",
          true
        );
        const activeSlots = response.data.filter((slot) => {
          const fromDate = moment(slot.fromDate, "MM/DD/YYYY", true);
          const toDate = moment(slot.toDate, "MM/DD/YYYY", true);
          return (
            slot.status === 1 &&
            selectedDate.isBetween(fromDate, toDate, "day", "[]")
          );
        });

        const timeSlots = generateTimeSlots(
          selectedDoctor?.selectedDate,
          activeSlots
        );
        setMorningSlots(timeSlots.morningSlots);
        setEveningSlots(timeSlots.eveningSlots);
      } else {
        setMorningSlots([]);
        setEveningSlots([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSlotsLoader(false);
    }
  };

  const handleSelectedTimeSlot = (selectedSlot) => {
    setSelectedSlot(selectedSlot);
  };

  const handleRoute = (route, payload) => {
    if (referralId) {
      payload.referralId = referralId;
    }
    navigate(route, { state: { appointmentPayload: payload } });
  };

  const handleContinueBooking = () => {
    const slotbookingPayload = {
      selectedDate,
      selectedSlot,
      selectedDoctor: displayingSlot,
      selectedPatient,
      consReason,
      consultationType,
      complaintCode: consCode ? consCode : "",
    };

    const fee =
      consultationType === "video"
        ? displayingSlot?.videoFee
        : consultationType === "inPerson"
        ? displayingSlot?.inpersonFee
        : displayingSlot?.homeVisitFee;

    const isFeeInvalid = fee <= 0;

    if (isFeeInvalid) {
      handleFreeBooking(slotbookingPayload);
    } else {
      handleRoute(APP_ROUTES.CHECKOUT, slotbookingPayload);
    }
  };

  const handleScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
    if (scrollLeft + clientWidth >= scrollWidth - 5) {
      loadMoreDates();
    }
  };

  const handleFreeBooking = (slotbookingPayload) => {
    dispatch(bookFreeAppointment(slotbookingPayload))
      .then((result) => {
        if (!result) {
          message.error("Registration Failed, Retry");
          return;
        }

        if (result?.data?.code === "SUCCESS") {
          closeDrawer();
          message.success("Appointment Booked Successfully");
        }
      })
      .catch((err) => {
        console.log("Booking Failed:", err);
        message.error("Booking Failed");
      });
  };

  const loadMoreDates = () => {
    const newLastDate = new Date(lastDate);
    newLastDate.setDate(lastDate.getDate() + 30);

    const newDates = generateDates(newLastDate, 30);
    setDates((prevDates) => [...prevDates, ...newDates]);
    setLastDate(newLastDate);
  };

  const handleSelectDate = (dateObj) => {
    try {
      const selectedDate = moment(dateObj.fullDate, "MM/DD/YYYY", true);
      if (!selectedDate.isValid()) {
        console.error("Invalid date selected:", dateObj.fullDate);
        return resetSlotState();
      }
      setSelectedDate(dateObj.fullDate);
      setSelectedSlot("");
      if (!selectedDoctorSlots || selectedDoctorSlots.length === 0) {
        return resetSlotState();
      }
      const activeSlots = selectedDoctorSlots.filter((slot) => {
        const fromDate = moment(slot.fromDate, "MM/DD/YYYY", true);
        const toDate = moment(slot.toDate, "MM/DD/YYYY", true);
        return (
          slot.status === 1 &&
          selectedDate.isBetween(fromDate, toDate, "day", "[]")
        );
      });
      if (activeSlots.length === 0) {
        return resetSlotState();
      }
      const slot = activeSlots[0];
      const consultationType =
        slot.video === "Y"
          ? "video"
          : slot.inPerson === "Y"
          ? "inPerson"
          : slot.homeVisit === "Y"
          ? "homeVisit"
          : "";

      setConsultationType(consultationType);
      setDisplayingSlot(slot);
      const timeSlots = generateTimeSlots(dateObj.fullDate, activeSlots);
      if (!timeSlots) {
        console.warn("No valid time slots generated.");
        return resetSlotState();
      }
      setMorningSlots(timeSlots.morningSlots);
      setEveningSlots(timeSlots.eveningSlots);
      setSlotVisible(true);
    } catch (error) {
      console.error("Error in handleSelectDate:", error);
      resetSlotState();
    }
  };

  const resetSlotState = () => {
    setSlotVisible(false);
    setMorningSlots([]);
    setEveningSlots([]);
    setDisplayingSlot(null);
    setSelectedSlot("");
  };

  const scrollLeft = () => {
    containerRef.current.scrollBy({ left: -100, behavior: "smooth" });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 100, behavior: "smooth" });
  };

  const handlePatientChange = (value) => {
    if (value === patientData?.patientId) {
      setSelectedPatient(patientData);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };
  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const handleConsReason = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await PatientService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleApptValidation = async () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    } else if (!consReason) {
      message.error("Please fill in the consultation reason.");
      return;
    }

    if (!selectedDate || !selectedSlot) {
      message.error("Please select Date and slot!");
      return;
    }

    if (
      (consultationType == "inPerson" || consultationType == "homeVisit") &&
      checkingPincode == ""
    ) {
      message.error("Enter Valid Pincode to check Service availability");
      return;
    } else {
      let payload = {
        userId: selectedDoctor.userId,
        clinicPincode: checkingPincode,
        displayInWebsite: "Y",
        status: 1,
      };
      const response = await UserService.getDoctors(payload);
      if (response.data.length == 0) {
        message.error("Consultation is not available in this entered pincode");
        return;
      }
    }
    if (consultationType == "homeVisit" && visitingAddress == "") {
      message.error("Enter Visiting Address");
      return;
    }

    handleContinueBooking();
  };

  const handleChange = (event) => {
    setConsultationType(event.target.value);
  };

  const convertTo12HourFormat = (time) => {
    return dayjs(time, "HH:mm").format("h:mm A");
  };

  return (
    <div className="p-2">
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="flex gap-2 border rounded-lg p-3">
        <div>
          {selectedDoctor.imageName ? (
            <img
              src={process.env.REACT_APP_IMAGE_URL + selectedDoctor?.imageName}
              alt={selectedDoctor.userName}
              className="rounded-full w-10 h-10"
            />
          ) : (
            <img
              src={doctorIcon}
              alt={selectedDoctor.userName}
              className="rounded-full w-10 h-10"
            />
          )}
        </div>
        <div>
          <p className="font-medium text-base">{`${selectedDoctor?.salutation}${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`}</p>
          <p className="text-xs font-medium text-gray-400 mt-1">
            {selectedDoctor?.qualification}
          </p>
          <div className="flex gap-2 mt-1">
            <IoLocationSharp className="mt-1 text-[#001a3fae]" />
            <p>
              {selectedDoctor?.city}, {selectedDoctor?.state}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-col-2">
        {!patientData?.parentPatientId && (
          <div className="p-3">
            {patientData?.patientId && (
              <div className="w-full">
                <label className="text-base font-semibold text-textGray">
                  Select Patient
                </label>
                <Select
                  className="w-full h-10"
                  value={selectedPatient?.patientId}
                  onChange={handlePatientChange}
                >
                  <Select.Option value={patientData?.patientId}>
                    {patientData?.firstName}
                  </Select.Option>
                  {famList.length !== 0 &&
                    famList.map((fam) => (
                      <Select.Option value={fam.patientId}>
                        {fam.firstName}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            )}
          </div>
        )}
        <div className="w-full text-primaryColor p-3 relative">
          <label className="text-base font-semibold text-textGray">
            Reason <span className="text-red-500">*</span>
          </label>
          <Input
            value={consReason}
            onChange={handleConsReason}
            className="w-[inherit] h-10 rounded-lg outline-none"
            placeholder="Enter Consultation Reason"
            maxLength={25}
          />
          {consultationReasonList.length > 0 && (
            <ul
              onMouseLeave={() => setConsultationReasonList([])}
              className="absolute w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20"
            >
              {consultationReasonList.map((reason, index) => (
                <li
                  onClick={() => handleConsSelectChange(reason)}
                  key={index}
                  className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                >
                  {reason.chiefComplaint}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {!slotsLoader && displayingSlot && (
        <div className="flex flex-col border-b pb-2 mt-3 ml-4">
          {/* Video */}
          {displayingSlot?.video === "Y" && (
            <label className="flex items-center space-x-2">
              <input
                type="radio"
                name="consultationType"
                value="video"
                className="accent-[#189FAA]"
                checked={consultationType === "video"}
                onChange={handleChange}
              />
              <span className="text-sm font-bold text-[#189FAA]">
                Video Consultation
              </span>
            </label>
          )}

          {/* In-Person */}
          {displayingSlot?.inPerson === "Y" && (
            <label className="flex items-center space-x-2 ">
              <input
                type="radio"
                name="consultationType"
                value="inPerson"
                className="accent-[#189FAA]"
                checked={consultationType === "inPerson"}
                onChange={handleChange}
              />
              <span className="text-sm font-bold text-[#189FAA]">
                In-Person Consultation
              </span>
            </label>
          )}

          {/* Home Visit */}
          {displayingSlot?.homeVisit === "Y" && (
            <label className="flex items-center space-x-2">
              <input
                type="radio"
                name="consultationType"
                value="homeVisit"
                className="accent-[#189FAA]"
                checked={consultationType === "homeVisit"}
                onChange={handleChange}
              />
              <span className="text-sm font-bold text-[#189FAA]">
                Home Visit
              </span>
            </label>
          )}

          {/* No Services */}
          {displayingSlot?.video === "N" &&
            displayingSlot?.inPerson === "N" &&
            displayingSlot?.homeVisit === "N" && (
              <span className="text-sm text-gray-500">
                No Consultation Services
              </span>
            )}
        </div>
      )}

      {(consultationType === "inPerson" ||
        consultationType === "homeVisit") && (
        <div className="mt-3">
          <div className="w-full flex flex-col text-primaryColor p-3">
            <label className="text-base font-semibold text-textGray">
              Enter Pincode <span className="text-red-500">*</span>
            </label>
            <input
              value={checkingPincode}
              onChange={(e) => setCheckingPincode(e.target.value)}
              type="text"
              placeholder="Enter an Indian pincode"
              className="flex-1 border border-gray-300 rounded p-2 text-sm outline-none"
            />
          </div>
        </div>
      )}
      {consultationType === "homeVisit" && (
        <div className="mt-1">
          <div className="w-full flex flex-col text-primaryColor p-3">
            <label className="text-base font-semibold text-textGray">
              Visiting Address <span className="text-red-500">*</span>
            </label>
            <textarea
              value={visitingAddress}
              onChange={(e) => setVisitingAddress(e.target.value)}
              type="text"
              placeholder="Enter Address"
              className="flex-1 border border-gray-300 rounded p-2 text-sm outline-none"
            />
          </div>
        </div>
      )}
      <div>
        {displayingSlot && (
          <div className="flex  justify-between items-center border-b pb-2 mb-4 mt-2 mx-2">
            <div className="text-lg font-medium">
              {consultationType === "video"
                ? "Video Consultation"
                : consultationType === "inPerson"
                ? "In-Person Consultation"
                : consultationType === "homeVisit"
                ? "Home Visit"
                : ""}
            </div>
            <div className="text-lg rounded-md p-1 bg-primaryColor text-white font-semibold">
              {consultationType === "video"
                ? displayingSlot?.videoFee
                : consultationType === "inPerson"
                ? displayingSlot?.inpersonFee
                : consultationType === "homeVisit"
                ? displayingSlot?.homeVisitFee
                : ""}
            </div>
          </div>
        )}
        {/* Date Selection */}
        <div className="w-full flex justify-evenly items-center gap-1 mb-4">
          {/* Left Arrow */}
          <div className="w-[10%]">
            <MdOutlineKeyboardArrowLeft
              onClick={scrollLeft}
              className="w-10 h-10 p-1 text-[#189FAA] cursor-pointer"
            />
          </div>

          {/* Date Container */}
          <div
            ref={containerRef}
            onScroll={handleScroll}
            className="flex items-center gap-3 overflow-x-auto scrollWidth"
            style={{ scrollBehavior: "smooth" }}
          >
            {dates.map((dateObj, index) => (
              <button
                key={index}
                onClick={() => handleSelectDate(dateObj)}
                className={`p-1 border rounded-md font-bold text-sm disabled:opacity-50 flex flex-col items-center ${
                  selectedDate === dateObj.fullDate
                    ? "bg-blue-100 border-[#189FAA]"
                    : "bg-white"
                }`}
              >
                <span>{dateObj.day}</span>
                <span>{dateObj.date}</span>
                <span>{dateObj.month}</span>
              </button>
            ))}
          </div>

          {/* Right Arrow */}
          <div className="w-[10%]">
            <MdKeyboardArrowRight
              onClick={scrollRight}
              className="w-10 h-10 text-[#189FAA] cursor-pointer"
            />
          </div>
        </div>
        {selectedDate && (
          <div className="p-1 font-semibold text-lg">
            {changeIntoString(selectedDate)}
          </div>
        )}
        {/* Slot Selection */}
        {slotsLoader ? (
          <div className="flex items-center justify-center h-[200px]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          <div className="flex flex-col items-center border-t">
            <div className="flex flex-col items-center mb-4">
              <p className="text-[#189FAA] font-semibold mt-2">MORNING SLOTS</p>
              {slotVisible && morningSlots.length !== 0 ? (
                <div className="flex justify-evenly flex-wrap gap-2 w-full mt-1">
                  {morningSlots.map((slot, index) => (
                    <button
                      key={index}
                      onClick={() => handleSelectedTimeSlot(slot)}
                      className={`px-4 py-2 border rounded-md ${
                        selectedSlot === slot
                          ? "bg-blue-100 border-[#189FAA]"
                          : "bg-white"
                      }`}
                    >
                      {convertTo12HourFormat(slot)}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="w-full h-[inherit] min-h-14 flex items-center justify-center">
                  <p className="font-semibold">No slots available</p>
                </div>
              )}
            </div>
            <div className="flex flex-col items-center mb-4">
              <p className="text-[#189FAA] font-semibold mb-2">
                AFTERNOON SLOTS
              </p>
              {slotVisible && eveningSlots.length !== 0 ? (
                <div className="flex justify-evenly flex-wrap gap-2 w-full mt-1">
                  {eveningSlots.map((slot, index) => (
                    <button
                      key={index}
                      onClick={() => handleSelectedTimeSlot(slot)}
                      className={`px-4 py-2 border rounded-md ${
                        selectedSlot === slot
                          ? "bg-blue-100 border-[#189FAA]"
                          : "bg-white"
                      }`}
                    >
                      {convertTo12HourFormat(slot)}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="w-full h-[inherit] min-h-14 flex items-center justify-center">
                  <p className="font-semibold">No slots available</p>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Continue Booking Button */}
        <button
          onClick={handleApptValidation}
          className="mt-4 w-full py-2 bg-[#189FAA] text-white font-semibold rounded-lg"
        >
          Continue Booking
        </button>
      </div>
    </div>
  );
};

export default SideDrawer;
